/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventToolModel3dFromJSON(json) {
    return StreemApiAnalyticEventToolModel3dFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventToolModel3dFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'elementId': !exists(json, 'element_id') ? undefined : json['element_id'],
        'modelId': !exists(json, 'model_id') ? undefined : json['model_id'],
    };
}
export function StreemApiAnalyticEventToolModel3dToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'element_id': value.elementId,
        'model_id': value.modelId,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventToolModel3d.js.map